<template>
  <div id="app">
    <b-container fluid="md">
      <div
        class="inovahplast__header mt-5 d-flex align-items-center justify-content-between"
      >
        <router-link to="/">
          <img
            src="@/assets/images/logo.png"
            class="img-fluid"
            style="width: 220px"
            alt="Logo InovahPlast"
          />
        </router-link>
        <b-icon-list font-scale="2" class="d-block d-md-none" @click="showMenu = !showMenu"></b-icon-list>
        <div class="inovahplast__contato d-none d-md-block">
          <small class="text-right">Atendimento</small>
          <p class="m-0">(11) 2946-1479</p>
          <p class="m-0">(11) 2936-7454</p>
        </div>
      </div>

      <nav
        class="navbar navbar-expand navbar-light mt-4 d-none d-md-block"
        style="background-color: #152b5e"
      >
        <div class="collapse navbar-collapse d-md-none">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item strong">
              <router-link to="/" class="nav-link text-white">Home</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/conheca-empresa" class="nav-link text-white"
                >+Inovah</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/produtos" class="nav-link text-white"
                >Produtos</router-link
              >
            </li>
            <li>
              <div class="dropdown">
                <div class="nav-link text-white">Segmentos</div>
                <div class="dropdown-menu p-3 rounded-0">
                  <router-link to="/produtos/segmento/automobilistico" class="dropdown-item"> Embalagens - Automobilística </router-link>
                  <router-link to="/produtos/segmento/cosmetico" class="dropdown-item"> Embalagens - Cosmética </router-link>
                  <router-link to="/produtos/segmento/farmaceutico" class="dropdown-item"> Embalagens - Farmacêutica </router-link>
                  <router-link to="/produtos/segmento/quimico" class="dropdown-item"> Embalagens - Química </router-link>
                </div>
              </div>
            </li>
            <li class="nav-item">
              <router-link to="/localizacao" class="nav-link text-white"
                >Localização</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/trabalhe-conosco" class="nav-link text-white"
              >Trabalhe Conosco</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/fale-conosco" class="nav-link text-white"
              >Contato</router-link
            >
            </li>
          </ul>
        </div>
      </nav>

      <div class="d-md-none mt-4" v-if="showMenu">
        <ul class="list-group list-group-flush" style="background-color: #152b5e">
          <li class="list-group-item" style="background-color: #152b5e" @click="showMenu = !showMenu">
            <router-link to="/" class="nav-link text-white">Home</router-link>
          </li>
          <li class="list-group-item" style="background-color: #152b5e" @click="showMenu = !showMenu">
            <router-link to="/conheca-empresa" class="nav-link text-white"
              >+Inovah</router-link
            >
          </li>
          <li class="list-group-item" style="background-color: #152b5e" @click="showMenu = !showMenu">
            <router-link to="/produtos" class="nav-link text-white"
              >Produtos</router-link
            >
          </li>
          <li class="list-group-item" style="background-color: #152b5e">
            <div class="nav-link text-white" @click="showSubMenu = !showSubMenu">Segmentos</div>
              <ul class="list-group list-group-flush" v-if="showSubMenu" @click="showMenu = !showMenu">
                <router-link to="/produtos/segmento/automobilistico" class="nav-link text-white" style="text-indent: 1rem"> Embalagens - Automobilística </router-link>
                <router-link to="/produtos/segmento/cosmetico" class="nav-link text-white" style="text-indent: 1rem"> Embalagens - Cosmética </router-link>
                <router-link to="/produtos/segmento/farmaceutico" class="nav-link text-white" style="text-indent: 1rem"> Embalagens - Farmacêutica </router-link>
                <router-link to="/produtos/segmento/quimico" class="nav-link text-white" style="text-indent: 1rem"> Embalagens - Química </router-link>
              </ul>
          </li>
          <li class="list-group-item" style="background-color: #152b5e" @click="showMenu = !showMenu">
            <router-link to="/localizacao" class="nav-link text-white"
              >Localização</router-link
            >
          </li>
          <li class="list-group-item" style="background-color: #152b5e" @click="showMenu = !showMenu">
            <router-link to="/trabalhe-conosco" class="nav-link text-white"
              >Trabalhe Conosco</router-link
            >
          </li>
          <li class="list-group-item" style="background-color: #152b5e" @click="showMenu = !showMenu">
            <router-link to="/fale-conosco" class="nav-link text-white"
            >Contato</router-link
            >
          </li>
        </ul>
      </div>

      <router-view></router-view>

      <footer
        class="text-white mt-5 px-md-0 px-3 pt-2 pt-md-5"
        style="background-color: #152b5e"
      >
        <div class="row d-flex justify-content-center">
          <div class="col-12 col-md-4 mt-3 mt-md-0">
            <p class="lead mb-1">Fale Conosco</p>
            <p class="m-0">Administrativo: (11) 2946-8338</p>
            <p class="m-0">Vendas: (11) 2893-5323 | (11) 2936-7454</p>
            <p class="m-0">Whatsapp: (11) 9 8184-3665</p>
          </div>
          <div class="col-0 border-right d-none d-md-block"></div>
          <div class="mt-5 mt-md-0 col-12 col-md-4">
            <p class="lead mb-1">Principais Segmentos</p>
            <p class="m-0"><router-link to="/produtos/segmento/automobilistico" class="text-decoration-none text-light"> Embalagens - Automobilística </router-link></p>
            <p class="m-0"><router-link to="/produtos/segmento/cosmetico" class="text-decoration-none text-light"> Embalagens - Cosmética </router-link></p>
            <p class="m-0"><router-link to="/produtos/segmento/farmaceutico" class="text-decoration-none text-light"> Embalagens - Farmacêutica </router-link></p>
            <p class="m-0"><router-link to="/produtos/segmento/quimico" class="text-decoration-none text-light"> Embalagens - Química </router-link></p>
          </div>
          <div class="col-0 border-right d-none d-md-block" style="width: 1px"></div>
          <div class="mt-5 mt-md-0 col-12 col-md-3">
            <p class="lead mb-1">Acompanhe nossos canais</p>
            <a href="https://www.facebook.com/InovahPlast/" target="_blank" class="text-decoration-none text-light mr-3"><font-awesome-icon :icon="['fab', 'facebook-square']" size="2x"></font-awesome-icon></a>
            <a href="https://www.linkedin.com/in/inovahplast-/" target="_blank" class="text-decoration-none text-light"><font-awesome-icon :icon="['fab', 'linkedin']" size="2x"></font-awesome-icon></a>
          </div>
        </div>
        <div class="row mt-md-5 mt-4 text-center">
          <p class="col-12 small">
            Todos os direitos reservados ©
            {{ new Date().getFullYear() }} Inovahplast
          </p>
        </div>
      </footer>
      <a href="https://api.whatsapp.com/send?phone=5511981843665" target="_blank">
        <img src="@/assets/images/icons/whatsapp.svg" class="whatsapp" width="40">
      </a>
    </b-container>
  </div>
</template>
dw
<script>
export default {
  name: "App",
  data() {
    return {
      showMenu: false,
      showSubMenu: false
    };
  },
  metaInfo: {
    titleTemplate: "%s | Inovahplast",
    meta: [
      { name: "description", content: "InovahPlast é uma empresa que atua à mais de 25 anos no mercado de embalagens plásticas voltadas para as linhas química, cosmética e automotiva." },
      { name: "keywords", content: "fb embalagens,linkedin,bio wash,atlas,combate,frasco de plastico,frascos plasticos,fábrica de frascos plásticos,frascos,fabrica,pl,ok,reciclavel,sustentabilidade,inovah plast sustentavel,inovah recicla,reciclar plastico,reciclando embalagens,embalengens reciclaveis ,materia prima pead reciclavel,embalagens para produtos quimicos,embalagens para quimico,materia prima pead,frascos em pead,fracos coloridos ,inovah plas sp,manhattan,manhattan embalegens plasticas ,manhattan inovahplast,sustentavel,inovahplast sustentavel,Bombona 5l,bombona,bombona 5000,bombona atlas,bombona combate,bombona 5000l,frasco agro,agro ,PEAD plástico,pead,inovahplast ,inovah,inova,inovahplast industria de embalagens,inovah plast ,plast ,inovah frascos,inovahplast embalens,morungaba sp,sala limpa,soprada,sp embalagens,embalagens para líquidos,embalagem pead,embalagens,plástico hdpe,embalagens pead,embalagens organicas,empresas de sopro plastico,empresa de envase,embalagens plasticas para produtos liquidos,empresas de sopro,sopro,pead plástico,embalagens plásticas para líquidos,frasco 500ml pead,emplas indústria de embalagens plásticas cnpj,transportadora,embalagens plasticas sopradas,recrutamento ,pote plastico,embalagem plásticas,embalagem joinville,potes de plastico descartavel,frasco borrifador,pote plástico descartável,pote de plástico com tampa de rosca,fabrica de potes plasticos para alimentos,pote para cosmeticos,ind plasticos,fabricante de potes plasticos para alimentos,potes ambar,fábrica de vasos plásticos,embalagens frascos plasticos,indústria de potes plásticos para alimentos,pote plastico com lacre,bisnaga de plástico 1000ml,pote plástico com tampa de rosca,pote plástico com tampa descartável 500ml,potes plasticos com tampa de rosca para alimentos,embalagem cuiabá,loja de embalagens em blumenau,potes embalagens,embalagens para mel de abelha,pote de plastico com tampa de rosca 500ml,potes de plastico com tampa descartavel,industria de potes plasticos,loja de cosméticos joinville,embalagens são josé sc,fabrica de potes plasticos para doces,frascos para shampoo atacado,embalagem para especiarias,frasco 500ml plástico,pote pet para alimentos,marcas de potes plásticos,industrias de frascos plasticos,embalagens ,bisnagas para cosméticos,frasco plástico 5000ml com tampa,fabricantes de frascos,potes pp,distrito industrial joinville,potes industriais,potes plasticos recife,potes de pet,frascos plasticos curitiba,indústria de embalagens plásticas para cosméticos,inovahplast trabalhe conosco,bisnaga plastica para mel,potes para suplemento alimentar,frascos de pet,embalagens bisnaga para mel,pote pet 250ml,bisnaga plastica transparente,embalagens cosmeticos bh,embalagens plasticas para cosmeticos sp,frascos plasticos para alimentos,pote plastico com tampa 750ml,embalagens para cosméticos sp,indústria de embalagens e frascos plásticos,nova rh joinville,pote hermético vidro 2l,pote de garrafa para pet,pote plástico com tampa 500ml,embalagem para mel 1kg,bisnaga embalagem,potes de plastico transparente,embalagem para cosmeticos atacado,embalagens cascavel,frasquinhos de plastico,potes de plástico com tampa,pote plástico transparente com tampa de rosca,potes plásticos para alimentos,batoque para garrafa,frascos para cosmeticos no atacado,fabrica de recipientes plásticos,indústria de plásticos,tipos de embalagens para cosmeticos,frascos de plástico,industria de plásticos,garrafa para colocar mel,garrafa com tampa flip top,bisnaga plástica transparente,potes para mel 500ml,frascos plasticos para remedios,industria de potes com lacre,frascos descartaveis,frasco plastico,frascos para creme,pote redondo 220ml,pode de mantimentos,pote grande plastico,frascos pequenos de plastico,fabrica de frascos plasticos em sp,fornecedor de embalagens farmaceuticas,embale embalagens,tampas para potes,frasco 500ml com tampa,pote plastico 1l,embalagens para especiarias,embalagens plasticas potes,potes com tampa de plástico,fabricante de frascos plasticos,embalagens pet,soda caustica,gel para ultrassom,soda em escamas,desinfetante ,agua sanitaria,agua de bateria,oleo de motor,frasco de 1 litro,embalagem de 1 litro,embalagem de 1.000 ml,frasco de 5 litros,embalagem de 5 litros,embalagem de 5.000 ml,frasco de meio litro,embalagem de meio litro,embalagem de 500 ml,detergente,amaciante,vanish,pó descolorante,graxa,desengraxante,fluido de corte,tinta para impressora,resina" }
    ]
  }
};
</script>

<style>
@font-face {
  font-family: Calibri;
  src: url("./fonts/Calibri-Regular.ttf");
}

#app {
}

.dropdown:hover .dropdown-menu{
  display: block;
  margin-top: 0;
}

.dropdown-item:active{
  background-color: #152b5e !important;
}

.whatsapp{
  position: fixed;
  right: 20px;
  bottom: 20px;
  cursor: pointer;
}

* {
  font-family: Calibri, Helvetica, Arial, sans-serif;
}
</style>
